import React from "react";
import styles from "./play_btn.module.scss";

export const PlayButton = (props) => {
  return (
    <div className={styles.play_btn} {...props}>
      <div className={styles.arrow_right}></div>
    </div>
  );
};

export default PlayButton;
